import React from 'react';
import { Layout } from 'antd';
import DashboardOverview from '../dashboard/DashboardOverview';
import DomainSetupCheck from '../websiteIndexEntry/DomainSetupCheck';
import LoaderCard from '../shared/LoaderCard';
import UrlFailedChecks from '../failedChecks/UrlFailedChecks';
import SiteWideChecks from '../failedChecks/SiteWideChecks';
import AddNewWebsiteForm from '../websiteIndexEntry/AddNewWebsiteForm';
import WebsiteIndexEntryTabs from '../websiteIndexEntry/WebsiteIndexEntryTabs';
import UrlClustersList from '../urlClusters/UrlClustersList';
import useGetCurrentWebsite from '../websiteIndexEntry/hooks/useGetCurrentWebsite';
import DefaultLayout from '../../trackedWebsites/DefaultLayout';

const { Content } = Layout;

export default function DashboardPage() {
    const { website, websiteIndexEntries, isLoading, setSelectedWebsite } = useGetCurrentWebsite();
    const websiteGuid = website?.guid;

    return (
        <Content className="general-layout-content">
            {isLoading && <LoaderCard />}

            {!isLoading && websiteGuid && (
                <>
                    <AddNewWebsiteForm onFinish={setSelectedWebsite} />
                    <WebsiteIndexEntryTabs>
                        <DomainSetupCheck key={websiteGuid} websiteGuid={websiteGuid}>
                            <DashboardOverview websiteGuid={websiteGuid} />
                            <UrlClustersList websiteGuid={websiteGuid} />
                            <SiteWideChecks websiteGuid={websiteGuid} />
                            <UrlFailedChecks websiteGuid={websiteGuid} />
                        </DomainSetupCheck>
                    </WebsiteIndexEntryTabs>
                </>
            )}

            {!isLoading && websiteIndexEntries && websiteIndexEntries.length === 0 && (
                <DefaultLayout />
            )}
        </Content>
    );
}
